import { createReducer, on } from '@ngrx/store';
import { CategoryInRoomCredentialsApiActions } from './category-in-room-credentials.actions';
import { adapter, initialState, selectId } from './category-in-room-credentials.state';

export const categoryInRoomCredentialsReducer = createReducer(
  initialState,
  on(
    CategoryInRoomCredentialsApiActions.categoryCredentialsLoaded,
    CategoryInRoomCredentialsApiActions.categoryCredentialsAdded,
    (state, { configuration }) => adapter.upsertOne(configuration, state)
  ),
  on(CategoryInRoomCredentialsApiActions.categoryCredentialsUpdated, (state, { configuration }) =>
    adapter.updateOne(
      {
        id: selectId(configuration),
        changes: configuration,
      },
      state
    )
  ),
  on(CategoryInRoomCredentialsApiActions.categoryCredentialsDeleted, (state, { configuration }) =>
    adapter.removeOne(selectId(configuration), state)
  )
);

const { selectIds, selectEntities, selectAll } = adapter.getSelectors();

export const selectCategoryInRoomCredentialsIds = selectIds;

export const selectCategoryInRoomCredentialsEntities = selectEntities;

export const selectAllCategoryInRoomCredentials = selectAll;
